import { create } from "apisauce";
import config from "config";
import qs from "qs";
import authApi from "./AuthApi";
import { reportsApi, reportsApiMock } from "./reportsApi";
import { cocreationApi, cocreationApiMock } from "./cocreationApi";
import resolutionApi from "./ResolutionApi";
import accountApi from "./AccountApi";
import { alertsApi, alertsApiMock } from "./alertsApi";
import {
  socialIndicatorsApi,
  socialIndicatorsApiMock
} from "./socialIndicatorsApi";
import { referenceDataApi, referenceDataApiMock } from "./ReferenceDataApi";
import { actionPlansApiMock, actionPlansApi } from "./actionPlansApi";
import { configurationApiMock, configurationApi } from "./ConfigurationApi";
import { dashboardApiMock, dashboardApi } from "./DashboardApi";

export const api = create({
  baseURL: window.LIMETROPY_UI_API_URL || config.baseApi,
  adapter: require('axios/lib/adapters/xhr'),
  paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  headers: {
    "Cache-Control": "no-cache",
    "Content-Type": "application/json; charset=utf-8",
    "access-control-allow-headers":
      "Content-Type, Accept, X-Requested-With, Authorization, X-Total-Count"
  },
  timeout: 300000
});

export default {
  /*configuration: JSON.parse(process.env.API_FROM_MOCKS)
    ? configurationApiMock(api)
    : configurationApi(api),*/
  configuration: configurationApiMock(api),
  auth: JSON.parse(process.env.API_FROM_MOCKS) ? authApi(api) : authApi(api),
  socialIndicators: JSON.parse(process.env.API_FROM_MOCKS)
    ? socialIndicatorsApiMock(api)
    : socialIndicatorsApi(api),
  referenceData: JSON.parse(process.env.API_FROM_MOCKS)
    ? referenceDataApiMock(api)
    : referenceDataApi(api),
  alertsIndicators: JSON.parse(process.env.API_FROM_MOCKS)
    ? alertsApiMock(api)
    : alertsApi(api),
  account: JSON.parse(process.env.API_FROM_MOCKS)
    ? accountApi(api)
    : accountApi(api),
  resolutions: resolutionApi(api),
  reports: JSON.parse(process.env.API_FROM_MOCKS) ? reportsApiMock(api) : reportsApi(api),
  cocreation: JSON.parse(process.env.API_FROM_MOCKS) ? cocreationApiMock(api) : cocreationApi(api),
  actionPlans: JSON.parse(process.env.API_FROM_MOCKS) ? actionPlansApiMock(api) : actionPlansApi(api),
  dashboard: JSON.parse(process.env.API_FROM_MOCKS)
    ? dashboardApiMock(api)
    : dashboardApi(api),
};



// WEBPACK FOOTER //
// ./src/services/api/index.js